import { ReactNode } from 'react';
import { InfoIcon } from '@rsos/base-assets/icons';
import { Text } from '@rsos/base-components';
import EventPaneBanner from '../../EventPaneBanner';

interface InfoBannerProps {
  children: ReactNode;
  backgroundColor?: string;
  color?: string;
}

const InfoBanner = ({ children, backgroundColor, color }: InfoBannerProps) => {
  return (
    <EventPaneBanner backgroundColor={backgroundColor} color={color}>
      <InfoIcon width={16} height={16} />
      <Text size="normal">{children}</Text>
    </EventPaneBanner>
  );
};

export default InfoBanner;
